import { RESTAURANT_OPEN_STATE_PREPARING } from 'src/consts/RESTAURANT_OPEN_STATE';

export default function isRestaurantClosed(restaurant_config) {
  let { restaurant_open_state } = restaurant_config;

  console.log('isRestaurantClosed', restaurant_config);

  return restaurant_open_state === RESTAURANT_OPEN_STATE_PREPARING;
}
